// Very short helper functions, add more complex ones to their own files

let uidSeq = 0;

export const getUid = () => {
    // Should conform to this pattern: "\d+-.+"
    return `${Date.now()}-${++uidSeq}`;
};

export const appendQueryParams = (url, params) => {
    const urlObj = new URL(url, window.location.origin);
    Object.entries(params).forEach(([key, value]) => {
        if(value !== undefined && value !== null) {
            urlObj.searchParams.set(key, value);
        }
    });
    return urlObj.toString();
};

export const getModifierKey = () => {
    if (navigator.userAgentData?.platform) {
        return navigator.userAgentData.platform === 'macOS' ? '⌘' : 'Ctrl';
    }
    return /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? '⌘' : 'Ctrl';
};

export const renderTextWithLineBreaks = (text) => text ? <div className="text-with-line-breaks">{text}</div> : null;

export const showUnsavedChangesConfirmationOverlay = (callback) => window.showUnsavedChangesConfirmationOverlay(callback);

export const showConfirmationOverlay = (id, heading, message, cancel, confirm, fromShoppingCart, overlayMainHtml) => {
    return window.show_confirmation_overlay(id, heading, message, cancel, confirm, fromShoppingCart, overlayMainHtml);
};

export const closeConfirmation = ({ t = term => term, ...config }) => {
    const id = config.id || 'ask-cancel-confirmation';
    const title = config.title || t('Confirm cancel');
    const message = config.message || t('Are you sure you want to close the dialogue? All changes will be lost.');
    const noLabel = config.noLabel || t('No, keep editing');
    const yesLabel = config.yesLabel || t('Yes, discard changes');

    return new Promise((resolve) => {
        window.show_confirmation_overlay(
            id,
            title,
            message,
            {
                label: noLabel, action: () => {
                    resolve(false);
                }
            },
            {
                label: yesLabel,
                action: () => {
                    resolve(true);
                },
            }
        );
    });
};

export const sanitizeHtml = function (s) {
    if (typeof s !== 'string') {
        return s
    }
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
    };
    const reg = /[&<>"']/ig;
    return s.replace(reg, function (match) { return map[match] });
}

export const slugify = (text, delim = '-') => {
    // Similar to Palaute/utils/strings.py slugify
    if (typeof text !== 'string') {
        text = String(text);
    }

    const cyrillicMap = {
        а: 'a', б: 'b', в: 'v', г: 'g', ґ: 'g6', д: 'd', е: 'e', є: 'ie', ж: 'zh',
        з: 'z', и: 'i', і: 'i', ї: 'ii', й: 'i', к: 'k', л: 'l', м: 'm', н: 'n',
        о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'kh', ц: 'ts',
        ч: 'ch', ш: 'sh', щ: 'shch', ь: '6', ю: 'iu', я: 'ia'
    };

    text = text
        .normalize('NFKD')
        .toLowerCase()
        .replace(/[\u0300-\u036f]/g, '');

    text = text.replace(/[а-яґєіїё]/g, ch => cyrillicMap[ch] || '');

    const result = text
        .replace(/[^a-z0-9]+/g, delim)
        .replace(new RegExp(`\\${delim}+`, 'g'), delim)
        .replace(new RegExp(`^\\${delim}|\\${delim}$`, 'g'), '');

    return result.replace(/'/g, '6').replace(/"/g, 'q') || delim;
};


export const cloneData = (data) => {
    if (!data) return data;

    if (typeof window.structuredClone === 'function') {
        try {
            return window.structuredClone(data);
        } catch (_) {
            // Non-cloneable values (functions, DOM, class instances) – use JSON fallback
        }
    }

    return JSON.parse(JSON.stringify(data));
};

export const removeHTMLTags = (htmlString) => {
    if (typeof htmlString !== 'string') {
        return htmlString;
    }
    return htmlString.replace(/<[^>]*>?/g, '');
}

export const getHashTabId = () => (typeof window !== 'undefined' ? (window.location.hash || '').slice(1) : '');
